import { Box } from "@material-ui/core";
import {TOKEN} from "constants/config";
import React from "react";
import {Navigate, RouteProps} from "react-router-dom";
import Header from "./pages/Header";

const HomeTemplate: React.FC<RouteProps> = ({children}) => {
  const token = localStorage.getItem(TOKEN);
  const role = localStorage.getItem("ROLE");
  return token && role === "STUDENT" ? (
    <Box style={{ backgroundColor: "#F8FAFC", minHeight: "100vh" }}>
      <Header />
      <Box style={{ backgroundColor: "#F8FAFC", minHeight: "calc(100vh - 70px)" }}>
        {children}
      </Box>
    </Box>
  ) : (
    <Navigate to="/" />
  );
};
export default HomeTemplate;
